import React from 'react';
import style from './style';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';

const SaveButton = ({ title, onClick, disabled }) => {
  return (
    <div style={style.saveButtonWrapper} onClick={disabled ? null : onClick}>
      <div style={disabled ? style.disabledTitle : style.title}>{title}</div>
      <FloatingActionButton disabled={disabled} mini>
        <ContentSave />
      </FloatingActionButton>
    </div>
  );
};

export default SaveButton;



// WEBPACK FOOTER //
// ./src/components/SaveButton/index.jsx